import Game from '../Game';

export abstract class State extends Phaser.State {
    game: Game;
}



// WEBPACK FOOTER //
// ./src/interfaces/state.ts